module.exports = __webpack_public_path__ + "img/bolso_props.7d45cb2e.png";